import React from 'react';
import Slider from 'react-slick';
import * as S from './style';
import { SectionLayout } from '../../components/Layouts';
import Icon from '../../components/Icon';
import { Col, Row } from '../../components/Grid';
import * as T from '../../components/Typography';

import HeadlineTitle from '../../components/Title/HeadTitle';

import Image from '../../components/PreviewCompatibleImage';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const OurPeapoleSection = ({ title, subtitle, data, preview, getAsset }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    prevArrow: (
      <S.Button type="button" className="button button--text button--icon" aria-label="prev">
        <S.PrevArrow>
          <Icon icon="leftArrow" width="22px" height="22px" to="prev" color="gray6" />
        </S.PrevArrow>
      </S.Button>
    ),
    nextArrow: (
      <S.Button type="button" className="button button--text button--icon" aria-label="next">
        <S.NextArrow>
          <Icon icon="leftArrow" width="22px" height="22px" to="prev" color="gray6" />
        </S.NextArrow>
      </S.Button>
    ),
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      <SectionLayout id="our-people" bgcolor="gray2">
        <Row>
          <Col w={[4, 6, 8]}>
            <HeadlineTitle>{title}</HeadlineTitle>
          </Col>
        </Row>
        <Row>
          <Col w={[4, 6, 8]} py="48px">
            <T.Body16 color="gray3" as="pre">
              {subtitle}
            </T.Body16>
          </Col>
        </Row>
        <Row>
          <Col w={[4, 6, 12]}>
            <T.H4 color="midnight">Our board</T.H4>
          </Col>
        </Row>
        {!!data.length && (
          <Row jc="center" jcM="flex-end">
            <Col w={[4, 6, 11.5]}>
              <S.SliderWrapper>
                <Slider {...settings}>
                  {data.map(
                    elem =>
                      elem && (
                        <Row jc="center">
                          <Col w={[4, 6, 12]}>
                            <S.Slide>
                              <S.ImgContainer>
                                <Image
                                  imageInfo={
                                    elem.item && preview
                                      ? { image: getAsset(elem.item.imageInfo).url }
                                      : elem.item.imageInfo
                                  }
                                  style={{
                                    width: 200,
                                    height: 200,
                                    borderRadius: '50%',
                                  }}
                                />
                                <T.H5 color="midnight">{elem.item && elem.item.name}</T.H5>
                                <T.Body16 color="gray3">{elem.item && elem.item.role}</T.Body16>
                              </S.ImgContainer>
                              <S.TextContainer>
                                <T.Body16 color="gray5">{elem.item && elem.item.text}</T.Body16>
                              </S.TextContainer>
                            </S.Slide>
                          </Col>
                        </Row>
                      ),
                  )}
                </Slider>
              </S.SliderWrapper>
            </Col>
          </Row>
        )}
      </SectionLayout>
    </>
  );
};

export default OurPeapoleSection;
